<template>
  <apexchart width="1000" height="500" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  data() {
    return {
      series: [{
        name: 'Сумма по полю ЦЕНА_ДЛЯ_ГП_разгр_За_Тонну',
        type: 'line',
        data: [378220.00, 177565.00, 1617305.00, 1298080.00, 1199610.00, 3311423.00, 3765732.00, 1562425.00]
      }, {
        name: 'Сумма по полю Масса разгруженная',
        type: 'column',
        data: [13278.70, 4592.25, 58628.84, 40382.67, 37233.39, 80850.45, 87097.42, 54561.42]
      }, {
        name: 'Сумма по полю Дистанция, км',
        type: 'column',
        data: [121048.18, 60999.34, 335371.28, 368870.82, 328795.98, 814558.17, 957675.89, 370012.72]
      }, {
        name: 'Сумма по полю Тонна/км',
        type: 'column',
        data: [3.12, 2.91, 4.82, 3.52, 3.65, 4.07, 3.93, 4.22]
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
        },
        title: {
          text: 'График 8 (смешанный)'
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: []
        },
        labels: ['3', '4', '7', '8', '9', '10', '11', '12'],
        xaxis: {
          type: 'category'
        },
        yaxis: [{
          title: {
            text: 'Сумма по полю',
          }
        }],
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        },
        stroke: {
          width: [2, 1, 1, 1]
        }
      },
    };
  }
};
</script>

<style scoped>

</style>